import { atomWithStorage, createJSONStorage } from 'jotai/utils';

interface IntensityState {
  value: number | null;
  unit: string | null;
}

const storage = createJSONStorage<IntensityState>(() => sessionStorage);

export const intensityAtom = atomWithStorage<IntensityState>(
  'intensity',
  { value: null, unit: null },
  storage
);
